import { render, staticRenderFns } from "./PortalCadastroPaciente.vue?vue&type=template&id=71d81a68&"
import script from "./PortalCadastroPaciente.vue?vue&type=script&lang=js&"
export * from "./PortalCadastroPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports